/*
单位台账接口
*/
import request from '@/utils/request'

//获取首页左上角信息

//购买入库
export function getGmrkTableList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/qytz/gmrktz",
    data:data
  });
}
//生产入库
export function getScrkTableList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/qytz/scrktz",
    data:data
  });
}
//使用出库
export function getSyckTableList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/qytz/sycktz",
    data:data
  });
}
//销售出库
export function getXsckTableList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/qytz/xscktz",
    data:data
  });
}
//其他出库
export function getQtckTableList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/qytz/qtcktz",
    data:data
  });
}
//其他入库
export function getQtrkTableList(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/qytz/qtrktz",
    data:data
  });
}
// 获取仓库下拉
export function getCkList() {
  return request({
    method: "get",
    url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
  });
}
